<template>
  <md-card>
    <md-card-content>
      <autoextra :collection="part" v-slot="{item,last,index}">
        <div class="columns" :class="{last: last}">
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-100">
              <label class="label">{{last ? 'New ' : ''}}Part {{!last ? index + 1 : ''}}</label>
            </div>
            <div class="md-layout-item md-size-10">
              <md-button class="md-primary md-round md-dense" v-on:click="findPart(index)">Find Sparepart</md-button>
             </div>
          </div>


          <div class="md-layout md-gutter">
            <input v-model="item.id" :readonly="true" type="hidden"/>
            <input v-model="item.service_estimate_spare_part_master_id" :readonly="true" type="hidden"/>
            <div class="md-layout-item md-small-size-100">
              <md-field >
                <label class="label" >Part Nama</label>
                <validation-provider  ref="spare_part_master_name"  v-slot="{ errors }">
                  <md-input  v-model="item.name" :readonly="true"/>
                  <span >{{ errors[0] }}</span>
                </validation-provider>
              </md-field>
            </div>

            <div class="md-layout-item md-small-size-100">
              <md-field >
                <label class="label" >Part Code</label>
                <md-input  v-model="item.code" :readonly="true"/>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100">
              <md-field >
                <label class="label" >Part Stock</label>
                <md-input  v-model="item.stock" :readonly="true"/>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100">
              <md-field >
                <label class="label" >Price</label>
                <md-input  v-model="item.price" :readonly="true"/>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100">
              <md-field >
                <label class="label" >Quantity</label>
                <md-input :max='item.stock'  v-model="item.service_estimate_spare_part_qty" @change="qtyChange(index,item.service_estimate_spare_part_qty)" type="text" v-on:keypress="NumbersOnly"/>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100">
              <md-field >
                <label class="label" >Discount(%)</label>
                <md-input v-model="item.service_estimate_spare_part_discount" @change="discountChange(index,item.service_estimate_spare_part_discount)" type="text" v-on:keypress="NumbersOnly"/>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100">
              <md-field >
                <label class="label" >Total</label>
                <md-input  v-model="item.total" :readonly="true"/>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100">
              <md-field >
                <label class="label" >Remarks</label>
                <md-input  v-model="item.service_estimate_spare_part_remark" />
              </md-field>
            </div>
            
          <md-card-actions>
            <md-button class="md-danger md-dense" @click="deleteColumn(index)" v-if="item.code">
              delete
            </md-button>
          </md-card-actions>
          </div>         
        </div>
      </autoextra>
    </md-card-content>
    <modal ref="modalList" class="coba">
        <template v-slot:header>
          <div>
            <h3>List Part</h3>
          </div>
          <md-button class="md-dense md-round md-icon-button" @click="CloseListPart()"><md-icon>close</md-icon></md-button>
        </template>

        <template v-slot:body>
          <list-part  :data_id="$refs.modalList.data"/>
        </template>

        <template v-slot:footer>
          <md-card-actions>
      <md-button @click="modalCloseList">
        Close
      </md-button>
          </md-card-actions>
        </template>
    </modal>
  </md-card>  
        
</template>
<script>
import { ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";
import  Autoextra  from 'vue-autoextra';
import {extend} from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import ListPart from "@/pages/Dashboard/Workshop/ServiceEstimate/ComponentForm/modal/ListPart.vue";
import { Modal } from "@/components";

extend('partname', {
  ...required,
  message: 'Please Select. Service is required'
  });

export default {
  name: "service-card",

  // props: {
  //   service_estimate: null,
  // },
  props: ['service_estimate'],
  components: { Autoextra, Modal, "list-part": ListPart  },

  mixins: [formMixin],

  data () {
    return {
      part: [],
      //options_part_list: null,
      index_modal: null,
    }
  },
  // watch: {
  //     part: function (newVal) {
  //       //Deteksi perubahan di part untuk di kirim ke parent
  //       this.$emit('data', newVal)
  //     }

  //   },
  created() {
          this.onOpen();
      },
   methods:{
     //fungsi yang di jalankan ketika page pertamakali dibuka
     async onOpen(){
       //ambil list data spare part
      //   await this.$store.dispatch("workshop_spare_part_master/list")
        
      //  this.options_part_list = await this.$store.getters["workshop_spare_part_master/list"]
      },

      NumbersOnly(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    
      findPart(index){
        this.index_modal = index
        this.$refs.modalList.openModal({warehouse_id: this.service_estimate.warehouse_workshop})
      },

      //fungsi untuk menutup modal list client
      modalCloseList(data){
       console.log(data)
        this.$refs.modalList.closeModal()
        if(data.id){
             if(this.part[this.index_modal]){

              this.$set(this.part, this.index_modal, {
                        id : this.part[this.index_modal].id,
                        service_estimate_spare_part_master_id : data.id,
                        name : data.spare_part_master_name,
                        code : data.spare_part_master_code,
                        stock : data.spare_part_master_stock,
                        price : data.spare_part_master_unit_price,
                        service_estimate_spare_part_qty : this.part[this.index_modal].service_estimate_spare_part_qty,
                        service_estimate_spare_part_discount : this.part[this.index_modal].service_estimate_spare_part_discount,
                        total : (data.spare_part_master_unit_price * this.part[this.index_modal].service_estimate_spare_part_qty) - ((data.spare_part_master_unit_price* this.part[this.index_modal].service_estimate_spare_part_qty) * this.part[this.index_modal].service_estimate_spare_part_discount/100),
                        service_estimate_spare_part_remark : this.part[this.index_modal].service_estimate_spare_part_remark
                        
                      });


            }
            else{
              

              this.$set(this.part, this.index_modal, {
                      id : null,
                      service_estimate_spare_part_master_id : data.id,
                      name : data.spare_part_master_name,
                      code : data.spare_part_master_code,
                      stock : data.spare_part_master_stock,
                      price : data.spare_part_master_unit_price,
                      service_estimate_spare_part_qty : 1,
                      service_estimate_spare_part_discount : null,
                      total : data.spare_part_master_unit_price * 1,
                      service_estimate_spare_part_remark : null
                      
                    });
            }
        }
       
      },

      CloseListPart(){
        this.$refs.modalList.closeModal();
      },

      //fungsi untuk menghapus row spare part
      deleteColumn(index){
        if (index > -1) {
           this.part.splice(index, 1)
            var filtered = this.part.filter(function (el) {
              return el != null;
            });
            this.part = filtered;
        }
        console.log(this.part);
        
      },
      //fungsi yang berjalan ketika ada perubahan focus di select sparepart
      // focusSelectChanged(index){
      //   console.log('focusSelectChanged')
      //   //check apakah var part dengan index item yang di select ada
      //   if(this.part[index]){
      //     //cari nomor index dari var options_part_list berdasarkan id item yang di select
      //     var indexOption = this.options_part_list.findIndex(p => p.id == this.part[index].service_estimate_spare_part_master_id)
      //     //set var part dengan index sesuai dengan yang di pilih 
      //     this.$set(this.part, index, {
      //               id : null,
      //               service_estimate_spare_part_master_id : this.part[index].service_estimate_spare_part_master_id,
      //               code : this.options_part_list[indexOption].spare_part_master_code,
      //               stock : this.options_part_list[indexOption].spare_part_master_stock,
      //               price : this.options_part_list[indexOption].spare_part_master_unit_price,
      //               service_estimate_spare_part_qty : 1,
      //               service_estimate_spare_part_discount : null,
      //               total : this.options_part_list[indexOption].spare_part_master_unit_price * 1,
      //               service_estimate_spare_part_remark : null
                    
      //             });
      //     }
        
      // },
      //fungsi ketika ada perubahan di select sparepart
      // onChangePart(index,event){
      //   //check apakah niali event tidak null
      //   if(event){
      //     //console.log('onChangePart')

      //     //cari nomor index dari var options_part_list berdasarkan item yang di select
      //     var indexOption = this.options_part_list.findIndex(p => p.id == event)
      //     // var indexOptionCode = this.options_part_list.findIndex(p => p.spare_part_master_code == this.part[index].code)
      //     // console.log(this.part[index].code)
      //     //  console.log(event+'-'+this.part[index].service_estimate_spare_part_master_id+'-'+indexOptionCode)
      //     //check apakah var part dengan index yang dipilih memiliki data qty, remark dan dicount
      //     if(this.part[index] && this.part[index].service_estimate_spare_part_qty && (this.part[index].service_estimate_spare_part_qty != 1 || this.part[index].service_estimate_spare_part_remark != null || this.part[index].service_estimate_spare_part_discount != null)){
      //      //jika ada re set kembali sesuai data yang sama
      //      this.$set(this.part, index, {
      //           id : this.part[index].id,
      //           service_estimate_spare_part_master_id : this.part[index].service_estimate_spare_part_master_id,
      //           code : this.part[index].code,
      //           stock : this.part[index].stock,
      //           price : this.part[index].price,
      //           service_estimate_spare_part_qty : this.part[index].service_estimate_spare_part_qty,
      //           service_estimate_spare_part_discount : this.part[index].service_estimate_spare_part_discount,
      //           total : (this.part[index].price * this.part[index].service_estimate_spare_part_qty) - ((this.part[index].price * this.part[index].service_estimate_spare_part_qty) * this.part[index].service_estimate_spare_part_discount/100),
      //           service_estimate_spare_part_remark : this.part[index].service_estimate_spare_part_remark
      //         });
      //         // console.log("a");
      //         // console.log(this.part[index].service_estimate_spare_part_qty)
      //         // console.log(this.part[index].service_estimate_spare_part_remark)
      //         // console.log(this.part[index].spare_part_master_unit_price)
      //     }
      //     else{
      //       //jika tidak ada set sesuai dengan nilai yang di dapat dari options_part_list dengan nomor index yang sudah didapatkan sebelumnya
      //       this.$set(this.part, index, {
      //             id : null,
      //             service_estimate_spare_part_master_id : event,
      //             code : this.options_part_list[indexOption].spare_part_master_code,
      //             stock : this.options_part_list[indexOption].spare_part_master_stock,
      //             price : this.options_part_list[indexOption].spare_part_master_unit_price,
      //             service_estimate_spare_part_qty : 1,
      //             service_estimate_spare_part_discount : null,
      //             total : this.options_part_list[indexOption].spare_part_master_unit_price * 1,
      //             service_estimate_spare_part_remark : null
                  
      //           });
      //         console.log("b");
      //       }
      //     }
      //   },
        //fungsi ketika ada perubahan di input qty, index nomor urut row
        qtyChange(index,qty){
          //check jika nilai qty tidak null
          if(qty){

          //console.log(this.part[index].service_estimate_spare_part_master_id)

          //cari nomor index dari options_part_list sesaui dengan id sparepart master yang ada di data row part
         // var indexOption = this.options_part_list.findIndex(p => p.id == this.part[index].service_estimate_spare_part_master_id)
          //set var part
          this.$set(this.part, index, {
                id : this.part[index].id,
                service_estimate_spare_part_master_id : this.part[index].service_estimate_spare_part_master_id,
                name : this.part[index].name,
                code : this.part[index].code,
                stock : this.part[index].stock,
                price : this.part[index].price,
                service_estimate_spare_part_qty : qty,
                service_estimate_spare_part_discount : this.part[index].service_estimate_spare_part_discount,
                total : (this.part[index].price * qty) - ((this.part[index].price * qty) * this.part[index].service_estimate_spare_part_discount/100),
                service_estimate_spare_part_remark : this.part[index].service_estimate_spare_part_remark
              });
            
            console.log("qtyChange");
          }

        },
        //fungsi ketika ada perubahan di input discount, index nomor urut row
        discountChange(index,discount){
          //check apakah nilai discount tidak null
          if(discount){

         // console.log(this.part[index].service_estimate_spare_part_master_id)
         //cari nomor index dari options_part_list sesaui dengan id sparepart master yang ada di data row part
         // var indexOption = this.options_part_list.findIndex(p => p.id == this.part[index].service_estimate_spare_part_master_id)
          //set var part
         this.$set(this.part, index, {
                id : this.part[index].id,
                service_estimate_spare_part_master_id : this.part[index].service_estimate_spare_part_master_id,
                name : this.part[index].name,
                code : this.part[index].code,
                stock : this.part[index].stock,
                price : this.part[index].price,
                service_estimate_spare_part_qty : this.part[index].service_estimate_spare_part_qty,
                service_estimate_spare_part_discount : discount,
                total : (this.part[index].price * this.part[index].service_estimate_spare_part_qty) - ((this.part[index].price * this.part[index].service_estimate_spare_part_qty) * discount/100),
                service_estimate_spare_part_remark : this.part[index].service_estimate_spare_part_remark
              });
            
            //console.log("discountChange");
          }

        },
        //fungsi yang di panggil dari sisi parent untuk mendapatkan data yang ada di page child ini
        getData() {
            this.$emit('data', this.part)
        },
        //fungsi untuk mendapatkan data dari parent, digunakan saat edit
        async getDataParent() {
      //     await this.$store.dispatch("workshop_spare_part_master/list")
        
      //  this.options_part_list = await this.$store.getters["workshop_spare_part_master/list"]
          //check apakah options_part_list null
          // if(!this.options_part_list){
          //   //jika null ambil data dari server
          //   await this.$store.dispatch("workshop_spare_part_master/list")
          //   this.options_part_list = await this.$store.getters["workshop_spare_part_master/list"]
          // }



          //loop untuk mengeset data row sparepart
           this.service_estimate.service_estimate_part.forEach(async (value, index) => {
            //ambil data setiap part untuk mendapatkan current stock
            var query = { filter: { warehouse: this.service_estimate.warehouse_workshop, id: value.service_estimate_spare_part_master_id} };
              await this.$store.dispatch("workshop_spare_part_master/list", query);
            var dataStock =  await this.$store.getters["workshop_spare_part_master/list"];

            //var indexOption = this.options_part_list.findIndex(p => p.id == value.service_estimate_spare_part_master_id)
            this.$set(this.part, index, {
                  id : value.id,
                  service_estimate_spare_part_master_id : value.service_estimate_spare_part_master_id,
                  name : value.part_master.spare_part_master_name,
                  code : value.part_master.spare_part_master_code,
                  stock : dataStock[0].spare_part_master_stock,
                  price : value.part_master.spare_part_master_unit_price,
                  service_estimate_spare_part_qty : value.service_estimate_spare_part_qty,
                  service_estimate_spare_part_discount :  value.service_estimate_spare_part_discount,
                  total : (value.part_master.spare_part_master_unit_price * value.service_estimate_spare_part_qty) - ((value.part_master.spare_part_master_unit_price * value.service_estimate_spare_part_qty) * value.service_estimate_spare_part_discount/100),
                  service_estimate_spare_part_remark : value.service_estimate_spare_part_remark
                });
          });
          
        },
        //fungsi yang di panggil dari sisi parent untuk mengecheck validasi form di page child ini
        async validateForm() {
            const spare_part_master_name = this.$refs['spare_part_master_name'];
          let result = []
              if(this.part.length == 0){
            result.push(
                await spare_part_master_name.validate().then(function(data){
                return data.valid
                })
            )
              } 
            
            return result.every(Boolean)
          
    }
        

    },
    mounted() {
        console.log('Component mounted.')
    }
};
</script>

<style lang="scss" scoped>

.columns{
  margin-bottom: 3ex;
  border-bottom: 5px solid black;
}

.coba{
  width:800px !important;
  margin: 50px auto !important;
  
  @media screen and (max-width: 992px) {
      width: 90% !important;
    }
}
</style>
